import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllEmployeesUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllEmployees/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllEmployeesUser = data;

    // console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllEmployeesUser;
};


const setActiveEmployees = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setEmployeesActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllEmployeesUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Employees  - ',response);


    return AllEmployeesUser;
};



const setDeletedEmployees = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setEmployeesDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllEmployeesUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Employees  - ',response);


    return AllEmployeesUser;
};




const setUpdateEmployees = async (dataEmployeesUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setEmployeesUpdate/'),{
        dataEmployeesUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllEmployeesUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Employees  - ',dataEmployeesUpdate,response);


    return AllEmployeesUser;
};


const setSaveNewEmployees = async (dataEmployeesUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewEmployees/'),{
        dataEmployeesUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllEmployeesUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Employees  - ',response, dataEmployeesUpdate);


    return AllEmployeesUser;
};

Mock.onGet('/api/reference/getAllEmployees').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllEmployeesUser = await getAllEmployeesUser();
    // console.log('С сервера пришло - ', AllEmployeesUser);

    // if (!AllEmployeesUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllEmployeesUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllEmployeesUser,
    ]


})


Mock.onPost('/api/reference/setActiveEmployees').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllEmployeesUser = await setActiveEmployees(id,val);

    // if (!AllEmployeesUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllEmployeesUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllEmployeesUser,
    ]


})

Mock.onPost('/api/reference/setDeletedEmployees').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllEmployeesUser = await setDeletedEmployees(id,val);

    // if (!AllEmployeesUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllEmployeesUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllEmployeesUser,
    ]


})


Mock.onPost('/api/reference/setUpdateEmployees').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataEmployeesUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Employees = await setUpdateEmployees(dataEmployeesUpdate);

    // console.log('Серовер вернул данные ',AllEmployeesUser);

    // if (!Employees) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Employees) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Employees,
    ]


})


Mock.onPost('/api/reference/setSaveNewEmployees').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataEmployeesUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Employees = await setSaveNewEmployees(dataEmployeesUpdate);

    // console.log('Серовер вернул данные ',AllEmployeesUser);

    // if (!Employees) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Employees) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Employees,
    ]
})